// No-op analytics provider.
//
// Installed by the facade when the deployment reports `provider: "none"`
// (analytics disabled, or config fetch failed). Lets the facade delegate
// unconditionally instead of null-checking a missing provider on every
// call — "analytics off" is just a provider that does nothing.

import type { AnalyticsProvider, AnalyticsConfig } from '../types';
import type { CurrentUser } from '../../stores/authStore';

export class NoopProvider implements AnalyticsProvider {
    async init(_config: AnalyticsConfig): Promise<void> {}
    identify(_user: CurrentUser): void {}
    reset(): void {}
    capture(_event: string, _properties?: Record<string, unknown>): void {}
    page(_name: string, _properties?: Record<string, unknown>): void {}
}
